module.exports = __webpack_public_path__ + "static/glacier-lagoon-8dec919d4cc6881cacef9ebb3da94934.png";